import {
  SEARCH_BLUR,
  SEARCH_FOCUS,
  UPDATE_SEARCH_TERM,
  SEARCH_KEYBOARD_UP,
  SEARCH_KEYBOARD_DOWN,
  SEARCH_KEYBOARD_ENTER,
} from '../actionTypes';

const initialState = {
  term: '',
  index: 0,
  results: [],
  focus: false,
};

function mod(n, m) {
  return ((n % m) + m) % m;
}

function handleBlur({ state }) {
  return {
    ...state,
    focus: false,
  };
}

function handleFocus({ state }) {
  return {
    ...state,
    focus: true,
  };
}

function handleUpdateTerm({ state, payload: { term, results } }) {
  return {
    ...state,
    term,
    results,
    index: 0,
  };
}

function handleEnter({ state }) {
  function open(link) {
    window.open(link, '_blank');
  }

  const { results, index } = state;

  if (results?.length){
    const target = results[index];

    if (target.links) {
      target.links.forEach(open);
    }else{
      open(target.link);
    }
  }

  return state;
}

function handleUp({ state }) {
  const { index, results } = state;

  if (!results?.length) return state;

  return {
    ...state,
    index: mod(index - 1, results.length),
  };
}

function handleDown({ state }) {
  const { index, results } = state;

  if (!results?.length) return state;

  return {
    ...state,
    index: mod(index + 1, results.length),
  };
}

const handlers = {
  [SEARCH_BLUR]: handleBlur,
  [SEARCH_FOCUS]: handleFocus,
  [UPDATE_SEARCH_TERM]: handleUpdateTerm,
  [SEARCH_KEYBOARD_UP]: handleUp,
  [SEARCH_KEYBOARD_DOWN]: handleDown,
  [SEARCH_KEYBOARD_ENTER]: handleEnter,
};

export default function(state, { type, ...payload }) {
  if(!state) state = initialState;
  
  const handler = handlers[type];

  if (!handler) return state;

  return handler({ state, payload });
}
